
import { onMounted, defineComponent, onBeforeUnmount, ref, toRefs, nextTick } from 'vue';
import { fileuPicture } from "@/api/home";
// 引入wangeditor组件
import WangEditor from 'wangeditor';
// 引入代码高亮组件
import hljs from 'highlight.js'
// 公共状态文件
// 官方文档：https://www.kancloud.cn/wangfupeng/wangeditor3/335774
export default defineComponent({
  name: 'Wangeditor',
  // 设置富文本编辑器的HTML内容
  props: ['contentHtml'],
  setup(props: any, content: any) {
    // 获取编辑器实例html
    const editor = ref();
    // 编辑器实例对象
    let instance: any = '';
    onMounted(() => {
      // 编辑器实例对象
      instance = new WangEditor(editor.value);
      // 自定义菜单
      instance.config.menus = [
        // 'head',
        'bold', //字体加粗
        'fontSize',//字号
        'fontName',//字体
        // 'italic',
        'underline',//下划线
        'strikeThrough',//删除线
        // 'indent',
        // 'lineHeight',
        'foreColor',
        // 'backColor',
        'link',
        'list',//列表
        // 'todo',
        'justify',//对其
        'quote',// 引用
        // 'emoticon',
        'image',
        // 'video',//视频
        // 'table',//表格
        'code',
        // 'splitLine',
        'undo',//撤销
        'redo',//恢复
      ];
      // 代码高亮
      instance.highlight = hljs;
      // 开启本地上传图片(这是后端上传链接)
      instance.config.uploadImgServer = fileuPicture;
      instance.config.uploadFileName = 'file';
      instance.config.uploadImgHeaders = {
        // 'Accept': 'text/x-json'
      }
      // 限制上传图片格式
      instance.config.uploadImgAccept = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
      // 开启本地上传视频(这是后端上传链接)
      // instance.config.uploadVideoServer = '/api/upload-video';
      // 设置编辑器高度
      instance.config.height = 350;
      // 设置编辑器页面层级
      instance.config.zIndex = 10;
      // 设置编辑器placeholder
      instance.config.placeholder = '请输入您的文字！';
      // 配置编辑器显示颜色
      instance.config.colors = [
        '#000000',
        '#eeece0',
        '#1c487f',
        '#4d80bf'
      ];
      // 忽略粘贴内容中的图片
      // instance.config.pasteIgnoreImg = true;
      instance.config.uploadImgHooks = {
        before: function (xhr, editor, files) {
          console.log("before:", xhr)
        },
        success: function (xhr, editor, result) {
          console.log("success:", result)
        },
        fail: function (xhr, editor, result) {
          console.log('是编辑器对象，', result)
        },
        error: function (xhr, editor) {
          // console.log('cuo')
          // 图片上传出错时触发
          // xhr 是 XMLHttpRequst 对象，editor 是编辑器对象
        },
        // 如果服务器端返回的不是 {errno:0, data: [...]} 这种格式，可使用该配置
        // （但是，服务器端返回的必须是一个 JSON 格式字符串！！！否则会报错）
        customInsert: function (insertImg, result, editor) {
          // 图片上传并返回结果，自定义插入图片的事件（而不是编辑器自动插入图片！！！）
          // insertImg 是插入图片的函数，参数editor 是编辑器对象，result 是服务器端返回的结果
          // 举例：假如上传图片成功后，服务器端返回的是 {url:'....'} 这种格式，即可这样插入图片：
          var url = result.data
          insertImg(url);
          // result 必须是一个 JSON 格式字符串！！！否则报错
        }
      };
      Object.assign(instance.config, {
        // wangeditor 值发生变化的时候
        onchange() {
          // 将值instance.txt.html() 传递至父组件
          content.emit('getWangEditorValue', instance.txt.html());
        },
        // 上传网络图片回调
        linkImgCallback(src: string) {
          console.log('图片 src ', src)
        },
        // 上传网络视频回调
        onlineVideoCallback(video: string) {
          
        }
      });
      instance.create();

      // 设置富文本编辑器的页面内容，父组件传递的
      console.log(props.contentHtml)
      nextTick(() => {
        setTimeout(() => {
          //此时可以获取到this.$refs.vueWangeditor对象
          instance.txt.html(props.contentHtml)
        }, 200)
      })
    });
    //  页面卸载
    onBeforeUnmount(() => {
      instance.destroy();
      instance = null;
    });
    return {
      editor,
    };
  },
});
